// Story 137 (E2, 03-dominio.md §7.4/§7.6) — the ONE aggregated warning shown when Sun refuses a return to
// PENDING because some fabrication order of the selection has an active job in a device.
//
// The frozen cross-repo contract is consumed VERBATIM (R-HANDOFF-1/2): `message` is the translation key
// `FabricationOrderHasActiveJobs`, and the detail travels in `activeJobs: [{fabricationOrderCode, deviceName}]`
// inside the error body that Api_Functions already keeps in `error.data`. Codes and device names are real
// plant data and are NEVER translated. If `activeJobs` is missing, null or empty (CA16 — a case the contract
// declares impossible), only the translated sentence is shown: no empty list, no UI error.

export const ACTIVE_JOBS_CONFLICT_KEY = 'FabricationOrderHasActiveJobs'

const DETAIL_SEPARATOR = ' — '
const DETAIL_JOINER = ', '

export const isActiveJobsConflict = (error) => error?.message === ACTIVE_JOBS_CONFLICT_KEY

export const formatActiveJobEvidences = (activeJobs) => {
  if (!Array.isArray(activeJobs)) return []
  return activeJobs
    .filter((job) => job && (job.fabricationOrderCode || job.deviceName))
    .map((job) => `${job.fabricationOrderCode ?? ''}${DETAIL_SEPARATOR}${job.deviceName ?? ''}`)
}

export const buildActiveJobsConflictMessage = (t_, errorData) => {
  const sentence = t_(ACTIVE_JOBS_CONFLICT_KEY)
  const details = formatActiveJobEvidences(errorData?.activeJobs)
  if (details.length === 0) return sentence
  return `${sentence}: ${details.join(DETAIL_JOINER)}`
}
